import { memo } from "react";
const ServiceSection = ({ project, updateProject, inputClass }) => {
  const addService = () => {
    updateProject("services", [...project.services, ""]);
  };

  const removeService = (index) => {
    const updated = project.services.filter((_, i) => i !== index);
    updateProject("services", updated);
  };

  const updateService = (index, value) => {
    const updated = [...project.services];
    updated[index] = value;
    updateProject("services", updated);
  };
  const buttonClass = "bg-blue-600 px-2 py-1 rounded";

  return (
    <div>
      <div className="flex justify-between items-center">
        <label className="text-sm text-slate-300">Services</label>

        <button type="button" onClick={addService} className={buttonClass}>
          + Add Service
        </button>
      </div>

      {project.services.map((service, index) => (
        <div key={index} className="flex gap-3 mt-4">
          <input
            type="text"
            placeholder="e.g. CCTV Installation"
            value={service}
            onChange={(e) => updateService(index, e.target.value)}
            className={inputClass}
          />

          <button
            type="button"
            onClick={() => removeService(index)}
            className="px-4 rounded-lg bg-red-600 hover:bg-red-700"
          >
            Remove
          </button>
        </div>
      ))}
    </div>
  );
};

export default memo(ServiceSection);
